import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-grow-1 me-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-capitalize"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Physician Not Added ")
const _hoisted_5 = { class: "ms-1 fas fa-exclamation-triangle text-warning" }
const _hoisted_6 = {
  key: 1,
  class: "d-flex text-success align-items-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save font-size-xl me-1 animated flash infinite slow" }, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Saving Physician... ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" ordered on ")
const _hoisted_11 = { class: "d-flex mt-1" }
const _hoisted_12 = {
  key: 0,
  class: "ms-2 task-status badge badge-pill badge-success"
}
const _hoisted_13 = { class: "ms-auto d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormatName = _resolveComponent("FormatName")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`physician-card ${_ctx.order.OrderId === _ctx.selectedOrder.OrderId ? 'active' : ''}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.showEditPhysician && !_ctx.isUpdateInProgress)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.order.PhysicianFirstName || _ctx.order.PhysicianLastName)
              ? (_openBlock(), _createElementBlock("strong", _hoisted_2, [
                  _createVNode(_component_FormatName, {
                    "first-name": _ctx.order.PhysicianFirstName,
                    "last-name": _ctx.order.PhysicianLastName,
                    format: "FN LN"
                  }, null, 8 /* PROPS */, ["first-name", "last-name"])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _hoisted_4,
                  _withDirectives(_createElementVNode("i", _hoisted_5, null, 512 /* NEED_PATCH */), [
                    [_directive_tooltip, { title: 'Order cannot be selected without a physician' }]
                  ])
                ]))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (!_ctx.showEditPhysician && _ctx.isUpdateInProgress)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_6, _hoisted_9))
        : _createCommentVNode("v-if", true),
      (_ctx.showEditPhysician && !_ctx.isUpdateInProgress)
        ? (_openBlock(), _createBlock(_component_TypeaheadInput, {
            key: 2,
            getData: _ctx.getPhysicianList,
            value: _ctx.selectedPhysician,
            placeholder: "Type to Search Physician...",
            "character-limit": 3,
            onValueChanged: _ctx.selectedPhysicianChanged
          }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", {
        class: _normalizeClass(`${_ctx.showEditPhysician || _ctx.isUpdateInProgress ? 'mt-2' : ''}`)
      }, [
        _hoisted_10,
        _createElementVNode("b", null, _toDisplayString(_ctx.formatDate(_ctx.order.OrderDate)), 1 /* TEXT */)
      ], 2 /* CLASS */),
      _createElementVNode("section", _hoisted_11, [
        _createElementVNode("span", {
          class: _normalizeClass(`task-status badge badge-pill badge-${_ctx.taskStatusNameColor(_ctx.order.OrderStatus)}`)
        }, _toDisplayString(_ctx.order.OrderStatus), 3 /* TEXT, CLASS */),
        (_ctx.order.OrderId === _ctx.selectedOrder.OrderId)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Selected "))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      (!_ctx.showEditPhysician)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-xs py-0 btn-outline-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openOrder(_ctx.order)))
            }, " Open Order "),
            (!_ctx.order.PhysicianFirstName && !_ctx.order.PhysicianLastName)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-xs py-0 btn-primary ms-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openAddPhysicianToOrder()))
                }, " Add Physician "))
              : _createCommentVNode("v-if", true),
            (
                        (_ctx.order.PhysicianFirstName || _ctx.order.PhysicianLastName) && _ctx.order.OrderId !== _ctx.selectedOrder.OrderId
                    )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-xs py-0 btn-success ms-1",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectOrder(_ctx.order)))
                }, " Select Order "))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (!_ctx.isUpdateInProgress && _ctx.showEditPhysician)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-xs py-0 btn-success",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addPhysicianToOrder()))
            }, "Save"),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-xs py-0 btn-outline-secondary ms-1",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeAddPhysicianToOrder()))
            }, " Cancel ")
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}